import React from "react";
import { RefreshIcon } from "@heroicons/react/outline";
import { SYNC_FREQUENCIES } from "../constants";

const SyncTab = ({ rateConfig, setRateConfig, rateMode }) => {
  const isSyncAvailable = rateMode === "LIVE" || rateMode === "HYBRID";

  const handleSyncToggle = (enabled) => {
    setRateConfig((prev) => ({
      ...prev,
      autoSync: {
        ...prev.autoSync,
        enabled,
      },
    }));
  };

  const handleFrequencyChange = (frequency) => {
    setRateConfig((prev) => ({
      ...prev,
      autoSync: {
        ...prev.autoSync,
        frequency,
      },
    }));
  };

  const handleSyncNow = () => {
    // Implement sync now functionality
    console.log("Syncing now...");
  };

  const handleViewHistory = () => {
    // Implement view history functionality
    console.log("Viewing sync history...");
  };

  if (!isSyncAvailable) {
    return (
      <div className="text-center py-12 text-gray-500">
        <RefreshIcon className="h-12 w-12 mx-auto mb-4 text-gray-300" />
        <p className="text-lg font-medium">Auto Sync Not Available</p>
        <p className="text-sm mt-2">
          Auto sync is only available when Rate Mode is set to LIVE or HYBRID
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-semibold mb-3">Auto Sync Settings</h4>
        <div className="space-y-3">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={rateConfig.autoSync.enabled}
              onChange={(e) => handleSyncToggle(e.target.checked)}
              className="h-4 w-4 text-blue-600 rounded mr-3"
            />
            <span className="font-medium">Enable automatic synchronization</span>
          </label>

          {rateConfig.autoSync.enabled && (
            <div className="ml-7 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sync Frequency
                </label>
                <select
                  value={rateConfig.autoSync.frequency}
                  onChange={(e) => handleFrequencyChange(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                >
                  {Object.values(SYNC_FREQUENCIES).map(freq => (
                    <option key={freq.value} value={freq.value}>
                      {freq.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4 pt-2">
                <button
                  type="button"
                  onClick={handleSyncNow}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center"
                >
                  <RefreshIcon className="h-4 w-4 mr-2" />
                  Sync Now
                </button>
                <button
                  type="button"
                  onClick={handleViewHistory}
                  className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  View Sync History
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <SyncStatus 
        lastSyncAt={rateConfig.autoSync.lastSyncAt}
        nextSyncAt={rateConfig.autoSync.nextSyncAt}
      />
    </div>
  );
};

const SyncStatus = ({ lastSyncAt, nextSyncAt }) => (
  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
    <h4 className="font-medium mb-2">Sync Status</h4>
    <div className="grid grid-cols-2 gap-4 text-sm">
      <div>
        <span className="text-gray-600">Last Sync:</span>
        <p className="font-medium">
          {lastSyncAt ? new Date(lastSyncAt).toLocaleString() : "Never"}
        </p>
      </div>
      <div>
        <span className="text-gray-600">Next Sync:</span>
        <p className="font-medium">
          {nextSyncAt ? new Date(nextSyncAt).toLocaleString() : "Not scheduled"}
        </p>
      </div>
    </div>
  </div>
);

export default SyncTab;
